import {ProductFilters} from "../helpers/products/filters.js";
import {ShoppingCartHelper} from "../helpers/shopping_cart/shopping_cart_helper.js";
import {AddProductToOrderlistModal} from "../helpers/orderlists/add_product_to_orderlist_modal.js";
import {DeleteOrderlistModal} from "../orderlists/delete_modal.js";
import {ProductGridItem} from "../templates/products/product_grid_item.js";
import {ProductTableRow} from "../templates/products/product_table_row.js";
import {ProductStockBadge} from "../templates/products/stock_badge.js";
import {PriceElements} from "../templates/products/price_elements.js";

class productsIndexPage {
    constructor() {

        this.currentPageIndex = 1;
        this.pageLength = window.localStorage.getItem('search_page_length') ?? 12;
        this.amountOfResults = 0;
        this.order = 0;
        this.stockCodeFilter = 0;

        this.records = [];

        this.placeholder = $('#placeholder-grid');
        this.resultsElement = $('#search-results-grid');
        this.resultsTableElement = $('#search-results-table');

        this.paginationElement = $('#pagination-element');
        this.paginationButtons = $('.pagination-buttons');
        this.paginationButtonsPlaceholder = $('#pagination-buttons-placeholder');
        this.urlParams = new URLSearchParams(window.location.search);

        this.searchResultsWrapper = $('#search-results-wrapper');
        this.emptyStateElement = $('#products-empty-state');

        this.isSignedIn = $('.dropdown.loggedin').length > 0;

        this.selectedView = window.localStorage.getItem('search-view') ?? 'grid';

        this.showNetPrices = $('#net-prices-switch').length > 0 && (localStorage.getItem('show_net_prices') !== null ? (localStorage.getItem('show_net_prices') === 'true') : true);
        $('#net-prices-switch').prop('checked', this.showNetPrices);

        this.managementMode = $('#filter-management-mode-switch').length > 0 && localStorage.getItem('filter_management_mode') === 'true';
        $('#filter-management-mode-switch').prop('checked', this.managementMode);
        document.body.classList.toggle('filter-management-mode', this.managementMode);

        this.investigationMode = $('#search-investigation-mode-switch').length > 0 && localStorage.getItem('search_investigation_mode') === 'true';
        $('#search-investigation-mode-switch').prop('checked', this.investigationMode);
        document.body.classList.toggle('search-investigation-mode', this.investigationMode);

        $(document).on('click', '.pagination-previous-page-btn', () => {
            this.currentPageIndex = this.currentPageIndex - 1;
            this.setQueryParameters();
        });

        $(document).on('click', '.pagination-btn', (event) => {
            this.currentPageIndex = parseInt($(event.currentTarget).attr('data-page-index'));
            this.setQueryParameters();
        });

        $(document).on('click', '.pagination-next-page-btn', () => {
            this.currentPageIndex = this.currentPageIndex + 1;
            this.setQueryParameters();
        });

        $('.sorting-btn').click((event) => {
            $('.sorting-btn.blue').removeClass('blue');
            $(event.currentTarget).addClass('blue');
            this.order = $(event.currentTarget).attr('data-order');
            this.setQueryParameters();
        });

        // Delegated (not bound directly) since #opties-filters-modal itself
        // gets replaced wholesale on every loadFilters() refresh - its items
        // are lazy-loaded here rather than embedded in that refresh (see
        // _loadOptionsModalItems()), since a broad query can have several
        // thousand of them and most visitors never open this modal at all.
        $(document).on('show.bs.modal', '#opties-filters-modal', () => {
            this._loadOptionsModalItems();
        });

        // Same lazy-load treatment, same reason: a broad query can match
        // well over a hundred manufacturers.
        $(document).on('show.bs.modal', '#manufacturers-filters-modal', () => {
            this._loadManufacturersModalItems();
        });

        this.loader = $('#products-loading-segment');

        if(this.resultsElement.length > 0) {
            this.loadFilters();
            this.applyQueryParameters();
            this.initStockPolling();
        }

        window.addEventListener(EVENT_SET_QUERY_PARAMETERS, (event) => {

            let pageLength = null;
            if(event.detail && event.detail['page-length']) {
                pageLength = event.detail['page-length'];
            }
            this.currentPageIndex = 1;
            this.setQueryParameters(pageLength);

            // Only this event means a filter (not just pagination/sort) changed,
            // so this is the one place the sidebar actually needs to re-narrow.
            this.loadFilters();
        });

        window.addEventListener('popstate', () => {
            this.urlParams = new URLSearchParams(window.location.search);
            this.applyQueryParameters();
            this.loadFilters();
        });

        $('#show-grid-view-btn').click(() => {
            if(this.selectedView !== 'grid') {
                $('#show-grid-view-btn').removeClass('btn-light').addClass('btn-primary');
                $('#show-list-view-btn').removeClass('btn-primary').addClass('btn-light');

                this.selectedView = 'grid';
                window.localStorage.setItem('search-view', 'grid');
                this.resultsTableElement.addClass('hidden');
                this.resultsElement.removeClass('hidden');
            }
        });

        $('#show-list-view-btn').click(() => {
            if(this.selectedView !== 'table') {
                $('#show-list-view-btn').removeClass('btn-light').addClass('btn-primary');
                $('#show-grid-view-btn').removeClass('btn-primary').addClass('btn-light');

                this.selectedView = 'table';
                window.localStorage.setItem('search-view', 'table');
                this.resultsElement.addClass('hidden');
                this.resultsTableElement.removeClass('hidden');
            }
        });

        if(this.selectedView === 'table') {
            $('#show-list-view-btn').removeClass('btn-light').addClass('btn-primary');
            $('#show-grid-view-btn').removeClass('btn-primary').addClass('btn-light');
        }

        $(document).on('input', '#filter-categories-input', $.debounce(function() {
            var searchString = $(this).val().trim().toLowerCase();
            if(searchString.length === 0) {
                $('.category-col.hidden').removeClass('hidden');
            } else {
                $('.category-title').each(function() {
                    if($(this).html().trim().toLowerCase().indexOf(searchString) !== -1) {
                        $(this).parent().parent().parent().removeClass('hidden');
                    } else {
                        $(this).parent().parent().parent().addClass('hidden');
                    }
                });

                if($('.category-col:not(.hidden)').length === 0) {
                    $('#categories-filter-empty-state').removeClass('hidden');
                } else {
                    $("#categories-filter-empty-state").addClass('hidden');
                }
            }
        }, 200));

        $(document).on('input', '#filter-manufacturers-input', $.debounce(function() {
            var searchString = $(this).val().trim().toLowerCase();
            if(searchString.length === 0) {
                $('.brand-column.hidden').removeClass('hidden');
            } else {
                var brandIdsToShow = {};
                $('.brand-text, .brand-serie-text').each(function() {
                    var brandId = $(this).attr('data-brand-id');
                    if($(this).html().trim().toLowerCase().indexOf(searchString) !== -1) {
                        brandIdsToShow[brandId] = true;
                    } else {
                        if(!brandIdsToShow[brandId]) {
                            brandIdsToShow[brandId] = false;
                        }
                    }
                });

                for (const [brandId, show] of Object.entries(brandIdsToShow)) {
                    if(show === true) {
                        $('.brand-column[data-brand-id=' + brandId + ']').removeClass('hidden');
                    } else {
                        $('.brand-column[data-brand-id=' + brandId + ']').addClass('hidden');
                    }
                }

                if($('.brand-column:not(.hidden)').length === 0) {
                    $('#manufacturers-filter-empty-state').removeClass('hidden');
                } else {
                    $("#manufacturers-filter-empty-state").addClass('hidden');
                }
            }
        }, 200));

        $(document).on('click', '.add-product-to-orderlist-btn', (event) => {

            const productId = $(event.currentTarget).attr('data-product-id');
            AddProductToOrderlistModal.showModal(this.getRecordById(productId));
        });

        $(document).on('click', '.product-link', (event) => {

            const productId = $(event.currentTarget).attr('data-product-id');
            if(productId) {
                window.localStorage.setItem('previously_selected_product_id', productId);
            }
        });

        $('#net-prices-switch').change((event) => {

            this.showNetPrices = $(event.currentTarget).is(':checked');
            localStorage.setItem('show_net_prices', this.showNetPrices === true ? 'true' : 'false');

            this.patchPriceElements();
        });

        $('#filter-management-mode-switch').change((event) => {

            this.managementMode = $(event.currentTarget).is(':checked');
            localStorage.setItem('filter_management_mode', this.managementMode === true ? 'true' : 'false');
            document.body.classList.toggle('filter-management-mode', this.managementMode);

            this.loadFilters();
        });

        $('#search-investigation-mode-switch').change((event) => {

            this.investigationMode = $(event.currentTarget).is(':checked');
            localStorage.setItem('search_investigation_mode', this.investigationMode === true ? 'true' : 'false');
            document.body.classList.toggle('search-investigation-mode', this.investigationMode);

            // Investigation data lives on search results, not the filter
            // sidebar - re-fetching filters here would do nothing useful.
            this.searchProducts();
        });
    }

    // Flipping this switch only ever changes the price column/badge, but used
    // to call renderRecords() and rebuild every card and row from scratch -
    // losing scroll position/open galleries/tooltip state on the rest of the
    // page just to update a price. Patching only .product-price-elements
    // (added to both the grid and table row templates) keeps everything else
    // on the page untouched.
    patchPriceElements() {
        this.records.forEach((record) => {
            const html = new PriceElements(record, this.showNetPrices).render();

            $('.product-col[data-product-id="' + record.id + '"] .product-price-elements, ' +
              '.product-search-result-item-row[data-product-id="' + record.id + '"] .product-price-elements')
                .each((i, el) => {
                    const $el = $(el);
                    $el.find('[data-bs-toggle="tooltip"]').each((j, tipEl) => {
                        const tooltip = bootstrap.Tooltip.getInstance(tipEl);
                        if (tooltip) tooltip.dispose();
                    });
                    $el.html(html);
                    $el.find('[data-bs-toggle="tooltip"]').each((j, tipEl) => {
                        new bootstrap.Tooltip(tipEl);
                    });
                });
        });
    }

    searchProducts(withScroll) {

        this.emptyStateElement.addClass('hidden');
        this.searchResultsWrapper.removeClass('hidden');
        this.paginationElement.removeClass('hidden');

        if(this.placeholder.hasClass('hidden')) {
            this.resultsElement.append(
                '<div id="products-loading-segment" class="rounded-1">' +
                    '<div class="spinner-border text-white" role="status">' +
                        '<span class="visually-hidden">Laden...</span>' +
                    '</div>' +
                '</div>'
            );
        }

        $('.pagination-button').addClass('disabled');

        if(withScroll) {
            $('html').animate({scrollTop: 0}, {duration: 400});
        }

        if(this.urlParams.get('query')) {
            $('#search-modal-input').val(this.urlParams.get('query'));
            $('#search-close').removeClass('hidden');
        }

        // Abort any still-in-flight search before starting a new one - rapid
        // filter/sort/page changes used to queue overlapping requests with no
        // guarantee the responses come back in the order they were sent, so a
        // slower earlier response could overwrite newer results on screen.
        if (this.currentSearchRequest && this.currentSearchRequest.readyState !== 4) {
            this.currentSearchRequest.abort();
        }

        // Keep the raw jqXHR itself (not the chain below) as
        // currentSearchRequest: jQuery's .then()/.catch()/.always() each
        // return a new promise object, and only the original jqXHR has
        // .abort() - assigning the chained result here (as this used to)
        // meant the abort() call above would find a plain promise with no
        // abort method on it.
        const searchRequest = $.post('/products/search', {
            query: this.urlParams.get('query'),
            category_id: this.urlParams.get('category-id'),
            category_filters: this.urlParams.get('C'),
            brand_filters: this.urlParams.get('B'),
            product_serie_filters: this.urlParams.get('S'),
            product_type_filters: this.urlParams.get('T'),
            spec_value_filters: this.urlParams.get('SV'),
            etim_char_filters: this.urlParams.get('SC'),
            price_low: this.urlParams.get('PL'),
            price_high: this.urlParams.get('PH'),
            page: this.currentPageIndex,
            page_length: this.pageLength,
            order: this.order,
            stock_status: this.urlParams.get('V'),
            gln_code: this.urlParams.get('gln'),
            is_outlet: this.urlParams.get('outlet'),
            action_id: this.urlParams.get('action'),
            investigationMode: this.investigationMode ? '1' : '0'
        });
        this.currentSearchRequest = searchRequest;

        searchRequest.then((response) => {

                $('#total-amount-of-records-span').html(response.results.length);
                if (response.results.length > 0) {

                    this.records = response.results;
                    // TODO: fix.
                    // this.emptyStateElement.addClass('hidden');
                    // this.searchResultsWrapper.removeClass('hidden');

                    this.amountOfResults = response.total_amount;
                    $('.total-amount-of-records-span').html(this.amountOfResults.toLocaleString());

                    $('#page-switcher .pagination').html(
                        '<li class="page-item active" aria-current="page">' +
                            '<span class="page-link">Pagina</span>' +
                        '</li>' +
                        '<li class="page-item pagination-btn ' + (this.currentPageIndex === 1 ? 'active' : '') + '" aria-current="page" data-page-index="1">' +
                            '<span class="page-link">1<span class="visually-hidden">(huidige)</span></span>' +
                        '</li>'
                    );

                    if(this.amountOfResults >= this.pageLength && this.amountOfResults > 24) {

                        const amountOfPages = Math.ceil(this.amountOfResults / this.pageLength);

                        if(amountOfPages >= 2) {

                            if(this.currentPageIndex - 1 > 1) {
                                $('#page-switcher .pagination').append(
                                    '<li class="page-item"><span class="page-link">...</span></li>'
                                );
                            }

                            if(this.currentPageIndex - 1 !== 0 && this.currentPageIndex - 1 !== 1) {
                                $('#page-switcher .pagination').append(
                                    '<li class="page-item pagination-btn" aria-current="page" data-page-index="' + (this.currentPageIndex - 1) + '"><span class="page-link">' + (this.currentPageIndex - 1) + '</span></li>'
                                );
                            }

                            if(this.currentPageIndex !== 1) {
                                $('#page-switcher .pagination').append(
                                    '<li class="page-item pagination-btn active" aria-current="page" data-page-index="' + this.currentPageIndex + '"><span class="page-link">' + this.currentPageIndex + '</span></li>'
                                );
                            }

                            if(this.currentPageIndex + 1 !== amountOfPages && (this.currentPageIndex + 1) < amountOfPages) {
                                $('#page-switcher .pagination').append(
                                    '<li class="page-item pagination-btn" aria-current="page" data-page-index="' + (this.currentPageIndex + 1) + '"><span class="page-link">' + (this.currentPageIndex + 1) + '</span></li>' +
                                    '<li class="page-item"><span class="page-link">...</span></li>'
                                );
                            }
                        }

                        if(this.currentPageIndex !== amountOfPages) {
                            $('#page-switcher .pagination').append(
                                '<li class="page-item pagination-btn" aria-current="page" data-page-index="' + amountOfPages + '"><span class="page-link">' + amountOfPages + '</span></li>'
                            );
                        }
                    }

                    let pageSizeValues = [];
                    switch (true) {
                        case this.amountOfResults > 96:
                            pageSizeValues = [24, 48, 96, -1];
                            break;
                        case this.amountOfResults > 48:
                            pageSizeValues = [24, 48, -1];
                            break;
                        case this.amountOfResults > 24:
                            pageSizeValues = [24, this.amountOfResults];
                            break;
                        default:
                            pageSizeValues = [this.amountOfResults];
                            break;
                    }
                    $('.page-size-select').prop('disabled', pageSizeValues.length <= 1);

                    let pageSizeHtml = '';
                    pageSizeValues.forEach((value, index) => {

                        let isSelected = value === parseInt(this.pageLength) ? ' selected' : '';
                        pageSizeHtml += '<option value="' + value + '"' + isSelected + '>' + (value !== -1 ? value : "Alle") + '</option>';
                    });
                    $('.page-size-select').html(pageSizeHtml);

                    if(this.selectedView === 'grid') {
                        this.resultsElement.removeClass('hidden');
                    } else {
                        this.resultsTableElement.removeClass('hidden');
                    }

                    this.renderRecords();

                    this.placeholder.addClass('hidden');
                    this.loader.removeClass('loading');
                    this.renderPaginationButtons();
                } else {

                    this.emptyStateElement.removeClass('hidden');
                    this.searchResultsWrapper.addClass('hidden');
                    this.resultsElement.addClass('hidden');
                    this.resultsTableElement.addClass('hidden');
                    this.placeholder.addClass('hidden');
                    this.paginationElement.addClass('hidden');
                }
            }
        ).catch(
            (error) => {
                if (error && error.statusText === 'abort') {
                    return;
                }
                console.log(error);
            }
        )
            .always((data, statusText) => {

                // A superseded request that we aborted ourselves - the newer
                // request already in flight will run this same cleanup once
                // it resolves, so running it now would act on stale results.
                if (statusText === 'abort') {
                    return;
                }

                const previouslySelectedProductId = window.localStorage.getItem('previously_selected_product_id');
                if(previouslySelectedProductId !== null && $('.product-col[data-product-id=' + previouslySelectedProductId + ']').length > 0) {

                    if(this.selectedView === 'grid') {

                        $('html, body').animate({ scrollTop: $('.product-col[data-product-id=' + previouslySelectedProductId + ']').offset().top - (window.innerHeight / 2)}, 1000);
                        $('.product-col[data-product-id=' + previouslySelectedProductId + ']').find('.card').addClass('border-primary');
                    } else {

                        $('html, body').animate({ scrollTop: $('.product-search-result-item-row[data-product-id=' + previouslySelectedProductId + ']').offset().top - (window.innerHeight / 2)}, 1000);
                        $('.product-search-result-item-row[data-product-id=' + previouslySelectedProductId + ']').addClass('bg-primary bg-opacity-10');
                    }
                }
                window.localStorage.removeItem('previously_selected_product_id');

                this.initGalleries();
            });
    }

    renderRecords() {

        let productsHtml = '';
        let productRowsHtml = '';
        $(this.records).each((index, currentResult) => {
            productsHtml += new ProductGridItem(currentResult, true, this.showNetPrices).render();
            productRowsHtml += new ProductTableRow(currentResult, this.showNetPrices).render();
        });

        this.resultsElement.html(productsHtml);
        this.resultsTableElement.find('tbody').html(productRowsHtml);

        // Activate Tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }

    // Many products have several web_images (some 10-50+), each rendered as a
    // hidden .gallery-item behind the main thumbnail. This used to preload every
    // one of those images (via new Image()) for every product on the page as
    // soon as search results rendered, purely to strip out broken URLs before
    // handing the gallery to lightGallery - regardless of whether the customer
    // ever opens that product's gallery. On a page of ~96 results that's
    // hundreds of extra network requests fired immediately after every search,
    // competing with the actually-visible thumbnails for the same limited
    // connections. Deferring this per-gallery until it actually scrolls into
    // view keeps the same broken-image handling and lightGallery setup, just
    // spread out instead of all at once.
    initGalleries() {

        if (!this._galleryObserver) {
            this._galleryObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }
                    observer.unobserve(entry.target);
                    this._initGallery(entry.target);
                });
            }, {rootMargin: '200px'});
        }

        document.querySelectorAll('.product-result-gallery').forEach((gallery) => {
            this._galleryObserver.observe(gallery);
        });
    }

    _initGallery(gallery) {

        if (gallery._lgInstance) {
            gallery._lgInstance.destroy();
            gallery._lgInstance = null;
        }

        // lightGallery reads every .gallery-item's href synchronously the
        // instant it's constructed below, and never looks at the DOM again -
        // so the main image needs the same broken-link check as the extras.
        // Without it, the inline onerror on the visible <img> (which corrects
        // the card thumbnail and this zoom button's href) almost always loses
        // the race: it only fires once the real network request actually
        // fails, whereas lightGallery constructs as soon as the extras check
        // resolves - immediately, for the common case of a product with no
        // extra web_images at all. The zoom lightbox would then be stuck
        // showing the dead link forever, even though the card itself recovers.
        const mainItem = gallery.querySelector('.product-gallery-zoom-btn');
        const extras = Array.from(gallery.querySelectorAll('.gallery-item.d-none'));
        const checks = extras.map(item => new Promise(resolve => {
            const img = new Image();
            img.onload  = resolve;
            img.onerror = () => { item.remove(); resolve(); };
            img.src     = item.getAttribute('href') || '';
        }));

        if (mainItem) {
            checks.push(new Promise(resolve => {
                const img = new Image();
                img.onload  = resolve;
                img.onerror = () => { mainItem.href = '/img/default/product.png'; resolve(); };
                img.src     = mainItem.getAttribute('href') || '';
            }));
        }

        Promise.all(checks).then(() => {
            gallery._lgInstance = lightGallery(gallery, {
                selector: '.gallery-item',
                plugins: [lgZoom, lgFullscreen],
                licenseKey: 'D4194FDD-48924833-A54AECA3-D6F8E646',
                download: false,
                zoomFromOrigin: false,
            });
        });
    }

    // Stock is imported/updated on its own schedule, independent of any
    // single customer's search session, so the numbers on already-rendered
    // badges can go stale the longer someone browses. Polling every 30s and
    // patching just the badge (not the whole card) keeps that number honest
    // without disturbing scroll position, open galleries, etc. Signed-out
    // visitors never see stock at all (see ProductStockBadge), so there's
    // nothing useful to poll for them - and the endpoint requires auth too.
    initStockPolling() {
        if (!this.isSignedIn) return;

        setInterval(() => {
            const productIds = [...new Set(
                $('[data-stock-badge-product-id]').map((i, el) => $(el).attr('data-stock-badge-product-id')).get()
            )];

            if (productIds.length === 0) return;

            $.post('/products/getStock', {product_ids: productIds.join(',')}).then((response) => {
                if (response.status !== 'success') return;

                response.products.forEach((product) => {
                    const record = this.records.find((r) => String(r.id) === String(product.id));

                    // Skip the DOM replace/tooltip recreate entirely when
                    // nothing actually changed since the last poll/render -
                    // most ticks touch none of the products on screen.
                    const unchanged = record &&
                        String(record.stock_code) === String(product.stock_code) &&
                        String(record.stock_amount) === String(product.stock_amount) &&
                        record.unit_type === product.unit_type;

                    if (unchanged) {
                        return;
                    }

                    if (record) {
                        record.stock_code   = product.stock_code;
                        record.stock_amount = product.stock_amount;
                        record.unit_type    = product.unit_type;
                    }

                    $('[data-stock-badge-product-id="' + product.id + '"]').each((i, badgeEl) => {
                        const $oldBadge   = $(badgeEl);
                        const isGridItem  = $oldBadge.attr('data-stock-badge-is-grid-item') === '1';
                        const oldTooltip  = bootstrap.Tooltip.getInstance(badgeEl);
                        if (oldTooltip) oldTooltip.dispose();

                        const $newBadge = $(new ProductStockBadge(product, isGridItem).render());
                        $oldBadge.replaceWith($newBadge);
                        new bootstrap.Tooltip($newBadge[0]);
                    });
                });
            }).catch((error) => {
                console.error('Failed to refresh stock badges:', error);
            });
        }, 30000);
    }

    renderPaginationButtons() {

        this.paginationButtons.empty();

        const amountOfPages = Math.ceil(this.amountOfResults / 10);
        if (this.amountOfResults <= 10) {

            this.paginationButtons.addClass('hidden');
        } else {

            this.paginationButtons.removeClass('hidden');
            let paginationButtonsHtml = '';
            if (amountOfPages <= 6) {

                for (let i = 1; i <= amountOfPages; i++) {
                    const activeClass = i === this.currentPageIndex ? 'blue' : '';
                    paginationButtonsHtml += '<button class="ui button ' + activeClass + ' pagination-btn" data-page-index="' + i + '">' + i + '</button>';
                }
            } else {

                if (this.currentPageIndex > 1) {
                    paginationButtonsHtml += '<button class="ui button icon pagination-previous-page-btn"><i class="icon arrow left"></i></button>';
                }

                if (this.currentPageIndex < 5) {

                    for (let i = 1; i < 6; i++) {
                        const activeClass = i === this.currentPageIndex ? 'blue' : '';
                        paginationButtonsHtml += '<button class="ui button ' + activeClass + ' pagination-btn" data-page-index="' + i + '">' + i + '</button>';
                    }
                    paginationButtonsHtml += '<button class="ui button disabled">...</button>';
                } else if (amountOfPages - this.currentPageIndex <= 5) {

                    paginationButtonsHtml += '<button class="ui button pagination-btn" data-page-index="1">1</button>';
                    paginationButtonsHtml += '<button class="ui button disabled">...</button>';
                    for (let i = amountOfPages - 5; i < amountOfPages; i++) {
                        const activeClass = i === this.currentPageIndex ? 'blue' : '';
                        paginationButtonsHtml += '<button class="ui button ' + activeClass + ' pagination-btn" data-page-index="' + i + '">' + i + '</button>';
                    }
                } else {

                    paginationButtonsHtml += '<button class="ui button pagination-btn" data-page-index="1">1</button>';
                    paginationButtonsHtml += '<button class="ui button disabled">...</button>';
                    for (let i = this.currentPageIndex - 1; i <= this.currentPageIndex + 1; i++) {
                        const activeClass = i === this.currentPageIndex ? 'blue' : '';
                        paginationButtonsHtml += '<button class="ui button ' + activeClass + ' pagination-btn" data-page-index="' + i + '">' + i + '</button>';
                    }
                    paginationButtonsHtml += '<button class="ui button disabled">...</button>';
                }

                if (this.currentPageIndex !== amountOfPages) {
                    paginationButtonsHtml += '<button class="ui button pagination-btn" data-page-index="' + amountOfPages + '">' + amountOfPages + '</button>';
                    paginationButtonsHtml += '<button class="ui button icon pagination-next-page-btn"><i class="icon arrow right"></i></button>';
                } else {
                    paginationButtonsHtml += '<button class="ui button pagination-btn blue" data-page-index="' + amountOfPages + '">' + amountOfPages + '</button>';
                }
            }

            this.paginationButtons.html(paginationButtonsHtml);
        }

        $('#pagination-buttons-placeholder').addClass('hidden');
    }

    setQueryParameters(pageLength = null) {

        if(this.currentPageIndex !== 1) {
            this.urlParams.set('page', this.currentPageIndex);
        } else {
            this.urlParams.delete('page');
        }

        this.order = parseInt($('input[name=sortingRadio]:checked').attr('value') ?? '0');
        this.urlParams.set('order', this.order);
        window.localStorage.setItem('search_order', this.order);
        if($('input[name=stockRadio]').length > 0) {
            this.urlParams.set('V', $('input[name=stockRadio]:checked').attr('value'));
        }

        const filters = ProductFilters.getFilterData();

        if(!filters['C']) {
            this.urlParams.delete('C');
        }
        if(!filters['B']) {
            this.urlParams.delete('B');
        }
        if(!filters['S']) {
            this.urlParams.delete('S');
        }
        if(!filters['T']) {
            this.urlParams.delete('T');
        }
        if(!filters['SV']) {
            this.urlParams.delete('SV');
        }
        if(!filters['SC']) {
            this.urlParams.delete('SC');
        }
        if(Object.keys(filters).length === 0) {
            this.urlParams.delete('C');
            this.urlParams.delete('B');
            this.urlParams.delete('S');
            this.urlParams.delete('T');
            this.urlParams.delete('SV');
            this.urlParams.delete('SC');
        } else {
            for (const [key, value] of Object.entries(filters)) {
                // SC values may contain commas (merged spec IDs); use | as logical-filter separator
                if (key === 'SC') {
                    if (value.length > 0) {
                        this.urlParams.set(key, value.join('|'));
                    } else {
                        this.urlParams.delete(key);
                    }
                    continue;
                }
                if (value.length > 0) {
                    this.urlParams.set(key, value);
                } else {
                    this.urlParams.delete(key);
                }
            }
        }

        if(filters.prices) {

            this.urlParams.set('PH', filters.prices.high);
            this.urlParams.set('PL', filters.prices.low);
        } else {
            this.urlParams.delete('PH');
            this.urlParams.delete('PL');
        }

        this.pageLength = pageLength !== null ? parseInt(pageLength) : parseInt($('.page-size-select').find('option:selected').val());

        if(typeof this.pageLength !== 'number') {
            this.pageLength = 24;
        }

        if(this.pageLength >= 24 || this.pageLength === -1) {
            window.localStorage.setItem('search_page_length', this.pageLength);
        }
        if(this.pageLength < 24 && this.pageLength !== -1) {
            this.pageLength = 24;
        }
        this.urlParams.set('pageSize', this.pageLength);

        const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + this.urlParams.toString();
        window.history.pushState({ path: newurl }, '', newurl);

        this.searchProducts(pageLength === null);
    }

    applyQueryParameters() {

        this.currentPageIndex = this.urlParams.has('page') ? parseInt(this.urlParams.get('page')): 1;

        this.pageLength = this.urlParams.has('pageSize') ? parseInt(this.urlParams.get('pageSize')) : window.localStorage.getItem('search_page_length') ?? 24;
        if(this.pageLength < 24 && this.pageLength !== -1) { this.pageLength = 24; }
        $('.page-size-select').val(this.pageLength);
        this.order = this.urlParams.has('order') ? parseInt(this.urlParams.get('order')) : window.localStorage.getItem('search_order') ?? 0;

        $('input[name=sortingRadio]').prop('checked', false);
        $('input[name=sortingRadio][value=' + this.order + ']').prop('checked', true);

        // If the stored order value doesn't match any option (e.g. stale localStorage), fall back to the default.
        if ($('input[name=sortingRadio]:checked').length === 0) {
            $('input[name=sortingRadio]').first().prop('checked', true);
            this.order = parseInt($('input[name=sortingRadio]').first().val());
        }

        if (parseInt(this.order) !== 0) {
            bootstrap.Collapse.getOrCreateInstance(document.getElementById('sortingBody')).show();
        }

        this.stockCodeFilter = this.urlParams.has('V') ? parseInt(this.urlParams.get('V')) : 0;

        $('input[name=stockRadio]').prop('checked', false);
        $('input[name=stockRadio][value=' + this.stockCodeFilter + ']').prop('checked', true);

        if (this.stockCodeFilter !== 0) {
            bootstrap.Collapse.getOrCreateInstance(document.getElementById('stockBody')).show();
        }

        const categoryFilters = this.urlParams.has('C') ? decodeURIComponent(this.urlParams.get('C')) : [];
        const brandFilters = this.urlParams.has('B') ? decodeURIComponent(this.urlParams.get('B')) : [];
        const productSerieFilters = this.urlParams.has('S') ? decodeURIComponent(this.urlParams.get('S')) : [];
        const productTypeFilters = this.urlParams.has('T') ? decodeURIComponent(this.urlParams.get('T')) : [];
        const specValueFilters = this.urlParams.has('SV') ? decodeURIComponent(this.urlParams.get('SV')) : [];
        const etimCharFilters  = this.urlParams.has('SC') ? decodeURIComponent(this.urlParams.get('SC')) : [];
        const priceLowFilter = this.urlParams.has('PL') ? decodeURIComponent(this.urlParams.get('PL')) : [];
        const priceHighFilter = this.urlParams.has('PH') ? decodeURIComponent(this.urlParams.get('PH')) : [];

        $('#activeFilters').empty();
        if(categoryFilters.length > 0) {
            ProductFilters.applyQueryFilters('C', categoryFilters.split(','));
        }
        if(brandFilters.length > 0) {
            ProductFilters.applyQueryFilters('B', brandFilters.split(','));
        }
        if(productSerieFilters.length > 0) {
            ProductFilters.applyQueryFilters('S', productSerieFilters.split(','));
        }
        if(productTypeFilters.length > 0) {
            ProductFilters.applyQueryFilters('T', productTypeFilters.split(','));
        }
        if(specValueFilters.length > 0) {
            ProductFilters.applyQueryFilters('SV', specValueFilters.split(','));
        }
        if(etimCharFilters.length > 0) {
            ProductFilters.applyQueryFilters('SC', etimCharFilters.split('|'));
        }

        if(priceLowFilter.length > 0 && priceHighFilter.length > 0) {
            ProductFilters.applyQueryFilters('PRICES', {low: priceLowFilter, high: priceHighFilter});
        }

        ProductFilters.renderActiveBadges();
        this.searchProducts();
    }

    // Shared between loadFilters() and _loadOptionsModalItems() - both ask
    // the server for the same current search/filter context, just render a
    // different slice of the result.
    _buildFilterParams() {
        const params = {};
        if (this.urlParams.get('query'))       params['query']       = this.urlParams.get('query');
        if (this.urlParams.get('category-id')) params['category-id'] = this.urlParams.get('category-id');
        if (this.urlParams.get('gln'))         params['gln']         = this.urlParams.get('gln');
        if (this.urlParams.get('outlet'))      params['outlet']      = this.urlParams.get('outlet');
        if (this.urlParams.get('action'))      params['action']      = this.urlParams.get('action');
        if (this.urlParams.get('C'))           params['category_filters']      = this.urlParams.get('C');
        if (this.urlParams.get('B'))           params['brand_filters']         = this.urlParams.get('B');
        if (this.urlParams.get('S'))           params['product_serie_filters'] = this.urlParams.get('S');
        if (this.urlParams.get('T'))           params['product_type_filters']  = this.urlParams.get('T');
        if (this.urlParams.get('SV'))          params['spec_value_filters']    = this.urlParams.get('SV');
        if (this.urlParams.get('SC'))          params['etim_char_filters']     = this.urlParams.get('SC');
        if (this.urlParams.get('V'))           params['stock_status']          = this.urlParams.get('V');
        if (this.managementMode)               params['managementMode']       = '1';

        return params;
    }

    // Lazy-loads the "Bekijk alle X opties" modal's contents the moment it's
    // actually opened (see the show.bs.modal listener in the constructor),
    // instead of it being embedded in every loadFilters() response - a broad
    // query can have several thousand distinct options, and most visitors
    // never open this modal at all. Re-fetched on every open (not cached
    // client-side) since the modal shell itself is replaced wholesale on
    // every filter refresh, and the options that belong in it depend on
    // whatever's currently selected.
    _loadOptionsModalItems() {
        const container = document.getElementById('modal-section-opties');
        if (!container) return;

        container.innerHTML =
            '<div class="col-12 d-flex justify-content-center py-4">' +
                '<div class="spinner-border text-primary" role="status">' +
                    '<span class="visually-hidden">Laden...</span>' +
                '</div>' +
            '</div>';

        $.get('/products/get-filter-options-modal', this._buildFilterParams()).then((html) => {
            container.innerHTML = html || '';
            this._initRangeSliders(document.getElementById('filters-modals-container'));
            this._syncSliderPositionsFromCheckboxes();
        }).catch((error) => {
            if (error && error.statusText === 'abort') {
                return;
            }
            console.error('Failed to load options modal:', error);
            container.innerHTML = '<p class="text-muted small">Kon de opties niet laden.</p>';
        });
    }

    // Same lazy-load pattern as _loadOptionsModalItems(), for the
    // "Fabrikanten" modal.
    _loadManufacturersModalItems() {
        const container = document.getElementById('modal-section-manufacturers');
        if (!container) return;

        container.innerHTML =
            '<div class="col-12 d-flex justify-content-center py-4">' +
                '<div class="spinner-border text-primary" role="status">' +
                    '<span class="visually-hidden">Laden...</span>' +
                '</div>' +
            '</div>';

        $.get('/products/get-filter-manufacturers-modal', this._buildFilterParams()).then((html) => {
            container.innerHTML = html || '';
        }).catch((error) => {
            if (error && error.statusText === 'abort') {
                return;
            }
            console.error('Failed to load manufacturers modal:', error);
            container.innerHTML = '<p class="text-muted small">Kon de fabrikanten niet laden.</p>';
        });
    }

    // Filter options are computed from whichever products currently match -
    // sending the already-checked filters along means the sidebar narrows to
    // only the values that still have results given everything selected so
    // far, instead of always showing the full unfiltered option set. Without
    // that, two checkboxes from different filter groups could combine to zero
    // results with nothing in the UI ever showing that was coming.
    loadFilters() {
        // The server always re-renders every accordion section back to its
        // template default (some start expanded, most start collapsed) -
        // without capturing what the customer actually had open first, a
        // panel they'd just expanded to check a box inside snaps shut right
        // after they do, with no indication why.
        const expandedAccordionIds = $('#filters-dynamic-area .accordion-collapse.show').map((i, el) => el.id).get();

        const params = this._buildFilterParams();

        // Abort any still-in-flight filters request before starting a new one -
        // checking two boxes in quick succession (e.g. two different filter
        // groups) fires loadFilters() twice, with no guarantee the responses
        // come back in the order they were sent. Without this, a slower
        // response for the FIRST (less-filtered) selection could land after
        // the second and overwrite the sidebar with stale options - the
        // options shown wouldn't match the actual combined filter state
        // anymore, even though the product results (protected by the same
        // abort pattern in searchProducts()) still show the correct count.
        if (this.currentFiltersRequest && this.currentFiltersRequest.readyState !== 4) {
            this.currentFiltersRequest.abort();
        }

        // Shown for the whole round trip - a rapid second call (another
        // checkbox, or the management-mode switch) removes and re-adds this
        // rather than stacking a second overlay on top.
        $('#filters-dynamic-area').find('.filters-loading-overlay').remove();
        $('#filters-dynamic-area').append(
            '<div class="filters-loading-overlay d-flex align-items-center justify-content-center">' +
                '<div class="spinner-border text-primary" role="status">' +
                    '<span class="visually-hidden">Laden...</span>' +
                '</div>' +
            '</div>'
        );

        const filtersRequest = $.get('/products/get-filters', params);
        this.currentFiltersRequest = filtersRequest;

        filtersRequest.then((html) => {
            if (!html || !html.trim()) {
                $('#filters-dynamic-area').empty();
                return;
            }

            const parsed     = $($.parseHTML(html));
            const sidebarEl  = parsed.filter('#ajax-filters-sidebar');
            const modalsEl   = parsed.filter('#ajax-filters-modals');

            if (sidebarEl.length) {
                $('#filters-dynamic-area').html(sidebarEl.html());
            } else {
                $('#filters-dynamic-area').empty();
            }

            if (modalsEl.length) {
                $('#filters-modals-container').html(modalsEl.html());
            }

            // Restore whatever was expanded before this refresh - ids are
            // stable across reloads (category/manufacturer/spec id-based), so
            // this only re-opens sections that still exist in the new markup.
            expandedAccordionIds.forEach((id) => {
                const el = document.getElementById(id);
                if (el && typeof bootstrap !== 'undefined') {
                    bootstrap.Collapse.getOrCreateInstance(el, { toggle: false }).show();
                }
            });

            ProductFilters.initOriginalIndices();

            // Re-apply URL filter state now that the DOM exists
            const catF  = this.urlParams.has('C')  ? decodeURIComponent(this.urlParams.get('C'))  : [];
            const brdF  = this.urlParams.has('B')  ? decodeURIComponent(this.urlParams.get('B'))  : [];
            const serF  = this.urlParams.has('S')  ? decodeURIComponent(this.urlParams.get('S'))  : [];
            const typF  = this.urlParams.has('T')  ? decodeURIComponent(this.urlParams.get('T'))  : [];
            const svF   = this.urlParams.has('SV') ? decodeURIComponent(this.urlParams.get('SV')) : [];
            const scF   = this.urlParams.has('SC') ? decodeURIComponent(this.urlParams.get('SC')) : [];

            if (catF.length > 0) ProductFilters.applyQueryFilters('C',  catF.split(','));
            if (brdF.length > 0) ProductFilters.applyQueryFilters('B',  brdF.split(','));
            if (serF.length > 0) ProductFilters.applyQueryFilters('S',  serF.split(','));
            if (typF.length > 0) ProductFilters.applyQueryFilters('T',  typF.split(','));
            if (svF.length  > 0) ProductFilters.applyQueryFilters('SV', svF.split(','));
            if (scF.length  > 0) ProductFilters.applyQueryFilters('SC', scF.split('|'));

            ProductFilters.renderActiveBadges();

            this._initRangeSliders(document.getElementById('filters-dynamic-area'));
            this._initRangeSliders(document.getElementById('filters-modals-container'));

            // After init, update slider positions to reflect any pre-applied range filters.
            this._syncSliderPositionsFromCheckboxes();

            this._makeModalSearch('opties-filters-modal', 'opties-modal-search', 'opties-no-results');
        }).catch((error) => {
            // A superseded request we aborted ourselves - the newer request
            // already in flight will render its own response once it resolves,
            // so clearing the sidebar now would just fight with that.
            if (error && error.statusText === 'abort') {
                return;
            }
            console.error('Failed to load filters:', error);
            $('#filters-dynamic-area').empty();
        });
    }

    _initRangeSliders(container) {
        if (!container || typeof noUiSlider === 'undefined') return;

        container.querySelectorAll('.range-slider').forEach((widget) => {
            const sliderUi = widget.querySelector('.range-slider-ui');
            const minInput = widget.querySelector('.range-slider-value-min');
            const maxInput = widget.querySelector('.range-slider-value-max');
            if (!sliderUi || sliderUi.noUiSlider) return; // skip if missing or already initialised

            const dataMin  = parseFloat(widget.dataset.min);
            const dataMax  = parseFloat(widget.dataset.max);
            const startMin = parseFloat(widget.dataset.startMin);
            const startMax = parseFloat(widget.dataset.startMax);
            const step     = parseFloat(widget.dataset.step) || 1;

            noUiSlider.create(sliderUi, {
                start:    [startMin, startMax],
                connect:  true,
                step:     step,
                tooltips: true,
                range:    { min: dataMin, max: dataMax },
                format: {
                    to:   (v) => Math.round(v * 1000) / 1000,
                    from: (v) => Number(v),
                },
            });

            // Keep min/max inputs in sync with the slider handle positions.
            sliderUi.noUiSlider.on('update', (values, handle) => {
                if (handle === 0 && minInput) minInput.value = values[0];
                if (handle === 1 && maxInput) maxInput.value = values[1];
            });

            // Move the slider when the user types into the inputs.
            if (minInput) minInput.addEventListener('change', function () { sliderUi.noUiSlider.set([this.value, null]); });
            if (maxInput) maxInput.addEventListener('change', function () { sliderUi.noUiSlider.set([null, this.value]); });

            // Apply filter on drag end.
            sliderUi.noUiSlider.on('change', () => {
                ProductFilters._applyRangeSliderFilter($(sliderUi).closest('.range-slider'));
            });
        });
    }

    _syncSliderPositionsFromCheckboxes() {
        document.querySelectorAll('.range-slider').forEach((widget) => {
            const sliderUi    = widget.querySelector('.range-slider-ui');
            const checkboxBox = widget.previousElementSibling;
            if (!sliderUi || !sliderUi.noUiSlider || !checkboxBox || !checkboxBox.classList.contains('slider-checkboxes')) return;

            const checked = Array.from(checkboxBox.querySelectorAll('.filter-checkbox.checked'));
            if (!checked.length) return;

            const nums = checked
                .map(cb => parseFloat(cb.getAttribute('data-numeric-value')))
                .filter(v => !isNaN(v));
            if (!nums.length) return;

            sliderUi.noUiSlider.set([Math.min(...nums), Math.max(...nums)]);
        });
    }

    _makeModalSearch(modalId, inputId, noResultsId) {
        const modal     = document.getElementById(modalId);
        const input     = document.getElementById(inputId);
        const noResults = noResultsId ? document.getElementById(noResultsId) : null;
        if (!modal || !input) return;

        const filterBlocks = () => {
            const query   = input.value.toLowerCase().trim();
            const blocks  = modal.querySelectorAll('[data-spec-name]');
            let visible   = 0;
            blocks.forEach((block) => {
                const name  = (block.getAttribute('data-spec-name') || '').toLowerCase();
                const match = !query || name.includes(query);
                block.style.display = match ? '' : 'none';
                if (match) visible++;
            });
            if (noResults) noResults.style.display = visible === 0 ? '' : 'none';
        };

        input.addEventListener('input', filterBlocks);
        modal.addEventListener('shown.bs.modal',  () => { input.focus(); });
        modal.addEventListener('hidden.bs.modal', () => { input.value = ''; filterBlocks(); });
    }

    getRecordById(recordId) {
        return this.records.find((currentRecord) => { return currentRecord['id'] === parseInt(recordId); });
    }
}

export let ProductIndexPage = new productsIndexPage();
